import React from 'react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import './form.css';

const Signup = () => {
    const [fullname, setFullname] = useState('');
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Submitting signup form:', { fullname, username, email }); // Debug log

        fetch('/api/signup', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json' // Add this header
            },
            body: JSON.stringify({
                fullname: fullname,
                username: username,
                email: email,
                password: password,
                schema: 'sunwin_is'
            })
        }).then(response => {
            console.log('Signup response status:', response.status); // Debug log
            if (!response.ok) {
                console.error('HTTP ERROR status', response.status);
                setMessage('Please check your details/ account already exist');
            } else {
                setFullname('');
                setUsername('');
                setEmail('');
                setPassword('');
                setMessage('Account Successfully Created');
            }
        }).catch(error => {
            console.error('error in adding new user', error);
            setMessage('Connection error. Please try again.');
        });
    };

    return (
        <div className="min-h-screen bg-gray-900 flex flex-col items-center pt-20">
            <h1 className="text-5xl text-white mb-8">Signup</h1>

            <div className="w-full max-w-md p-8 border border-gray-700 rounded-lg bg-gray-900">
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="space-y-2">
                        <label className="block text-gray-300">Enter your Full Name</label>
                        <input
                            type="text"
                            value={fullname}
                            onChange={(e) => setFullname(e.target.value)}
                            required
                            className="w-full p-2 rounded-md bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div className="space-y-2">
                        <label className="block text-gray-300">Enter a Username</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            className="w-full p-2 rounded-md bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div className="space-y-2">
                        <label className="block text-gray-300">Enter your email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="w-full p-2 rounded-md bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div className="space-y-2">
                        <label className="block text-gray-300">Enter a Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full p-2 rounded-md bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    {message && (
                        <div className={`text-center ${message.includes('Successfully') ? 'text-green-500' : 'text-red-500'}`}>
                            <p>{message}</p>
                        </div>
                    )}

                    <div className="flex justify-center mt-8">
                        <button
                            type="submit"
                            className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            Submit
                        </button>
                    </div>

                    <div className="text-center mt-4">
                        <p className="text-gray-300">
                            Already have a login? {" "}
                            <Link to="/login" className="text-blue-400 hover:text-blue-300">
                                Login instead!
                            </Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Signup;